import { Title } from '@components/atoms/Title';
import { useEditUser } from './useEditUser';
import { Button, Label } from '@components/atoms';
import { FieldRenderer } from '@components/organism';
import { useAllFieldsForms } from '@hooks/useAllFieldsForms';
import { urlZaf } from '@services/Zendesk';
import Input from '@components/atoms/Input/Input';
import { useUserContext } from '@context/UserContext';
import { formatRole } from '@hooks/masks';

export function EditUser() {
  const {
    handleProceed,
    selectedUser,
    navigate,
    error,
    isChecking,
    emailError,
    existUserEmail,
    account,
    isButtonDisabled,
    cnpjError,
    shouldDisableField
  } = useEditUser();
  const { userRoles } = useUserContext();

  const allFields = useAllFieldsForms(account as any);

  if (!selectedUser) {
    return <div className="p-4">Nenhum usuário selecionado.</div>;
  }

  return (
    <div className="p-4">
      <Title
        subtitle={`Preencha os dados da conta do tipo ${selectedUser.role ? formatRole(selectedUser.role) : ''}`}
        title="• Editar conta"
      />
      <div className="flex flex-col gap-4 h-100 overflow-y-auto max-h-[calc(100vh-100px)] mt-5">
        {allFields.map((field) => {
          if (field.customField) {
            return (
              <div key={field.id}>
                <FieldRenderer
                  field={field as any}
                  value={field.value}
                  onChange={field.onChange as any}
                  maxLength={
                    {
                      cpf_3: 14,
                      endereco_2: 60,
                    }[field.key as string]
                  }
                />
                {field.key === 'endereco_2' && (
                  <p className="text-gray-500 text-sm">
                    {field.value ? field.value.length : 0}/60 caracteres
                  </p>
                )}
              </div>
            );
          } else {
            return (
              <div key={field.id}>
                <Label title={field.title} />
                <Input
                  type={field.type}
                  name={field.key}
                  value={field.value as string}
                  onChange={(e) => field.onChange(e.target.value)}
                  maxLength={
                        {
                          phone: 10,
                          endereco_2: 60,
                          cpf_3: 14,
                          cnpj_regex: 18
                        }[field.key as string]
                      }
                  onKeyPress={(e) => {
                    if (field.key === 'cpf_3') {
                      if (!/^[0-9.-]$/.test(e.key)) {
                        e.preventDefault();
                      }
                    }
                  }}
                  disabled={shouldDisableField(
                    field.key,
                    selectedUser?.user_fields[field.key],
                    userRoles
                  )}
                />
                {field.key === 'cpf_3' && account.cpfError && (
                  <p className="text-red-500 text-sm mt-1">{account.cpfError}</p>
                )}
                {field.key === 'cnpj_regex' && cnpjError && (
                  <p className="text-red-500 text-sm mt-1">{cnpjError}</p>
                )}
                {field.key === 'cpf_3' && account.existUser && (
                  <p className="text-gray-500 text-sm mt-1">
                    Usuário encontrado:{' '}
                    <a
                      href={`${urlZaf}/users/${account.existUser.id}`}
                      target="_blank"
                      className="text-blue-600 underline text-sm mt-1"
                    >
                      {account.existUser.name}
                    </a>
                  </p>
                )
                }
                {
                  field.key === 'email' && account.emailRemovalError && (
                    <p className="text-red-500 text-sm mt-1">{account.emailRemovalError}</p>
                  )
                }
                {
                  field.key === 'email' && account.existUserEmail && (
                    <p className="text-gray-500 text-sm mt-1">
                      Usuário encontrado:{' '}
                      <a
                        href={`${urlZaf}/users/${account.existUserEmail.id}`}
                        target="_blank"
                        className="text-blue-600 underline text-sm mt-1"
                      >
                        {account.existUserEmail.name}
                      </a>
                    </p>
                  )
                }
              </div>
            );
          }
        })}
      </div>

      <div className="fixed bottom-0 left-0 w-full bg-white p-4 border-t border-gray-200">
        <div className="flex flex-col gap-2">
          <Button
            isPrimary
            isStretched
            onClick={handleProceed}
            disabled={isButtonDisabled || !!error || isChecking || !!emailError || !!existUserEmail}
          >
            Prosseguir
          </Button>
          <Button onClick={() => navigate('/')} isStretched>
            Voltar
          </Button>
        </div>
      </div>
    </div >
  );
}